const add_font_dom = (font) => {
  return new Promise((resolve,reject)=>{
    const new_font = new FontFace(font.family, `url(${font.url})`)
    new_font.load().then((loaded_font)=>{
      document.fonts.add(loaded_font)
      resolve("font added")
    })
    if(new_font.status == 'error') {
      reject('error adding font')
    }
  })
}

export default add_font_dom
